"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferedAsType = exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["INDIVIDUAL"] = "INDIVIDUAL";
    ServiceType["GROUP"] = "GROUP";
    ServiceType["COURSE"] = "COURSE";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType = exports.OfferedAsType || (exports.OfferedAsType = {}));
//# sourceMappingURL=catalog-service.dto.js.map